<template>
  <v-container fluid class="fill-height align-start">
    <Loading v-if="loading" />
    <div v-else class="fill-width refund-details pa-2">
      <v-row
        class="fill-width flex-column ma-0"
        align="center"
        justify="center"
      >
        <v-img
          v-if="refundDetails.logo"
          width="94"
          height="94"
          contain
          :src="refundDetails.logo"
        />
        <!--      <v-tooltip top color="primary">-->
        <!--        <template v-slot:activator="{ on, attrs }">-->
        <!--          <v-icon small color="blue" v-bind="attrs" v-on="on" class="mt-4"-->
        <!--            >mdi-information-outline</v-icon-->
        <!--          >-->
        <!--        </template>-->
        <!--        <span>{{ $t("panel.transactionPage.refund.details.tooltip") }}</span>-->
        <!--      </v-tooltip>-->
        <v-card-title
          >{{ $t("panel.transactionPage.refund.details.title") }}
          {{ refundDetails.cryptoAmount }}</v-card-title
        >
        <v-chip
          label
          :color="
            $transactionStatusColor(refundDetails.transactionStatus).color
          "
          :text-color="
            $transactionStatusColor(refundDetails.transactionStatus).textColor
          "
          class="text-center"
          >{{ refundDetails.transactionStatus }}</v-chip
        >
        <!--      <v-card-actions>-->
        <!--        <v-btn color="primary" class="elevation-0">{{-->
        <!--          $t("panel.transactionPage.refund.details.checkStatus")-->
        <!--        }}</v-btn>-->
        <!--      </v-card-actions>-->
        <v-card class="align-self-start fill-width" elevation="0">
          <ul
            v-for="item in $t('panel.transactionPage.refund.details.cardTitle')"
            :key="item.value"
            class="px-0 details"
          >
            <v-card class="d-flex align-center justify-start" elevation="0">
              <v-card-text class="width-auto pe-1 text-no-wrap">{{
                item.text
              }}</v-card-text>
              <v-tooltip
                v-if="item.tooltip"
                top
                color="primary"
                class="width-auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="blue" v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
              <v-card-text
                v-if="!item.condition"
                class="width-auto font-medium-16 gray10--text ml-auto text-right details-value"
                ><span v-if="item.value !== 'transactionTime'">{{
                  refundDetails[item.value]
                }}</span
                ><span v-else>{{
                  refundDetails[item.value] | $renderDate
                }}</span></v-card-text
              >
              <a
                v-else
                :href="refundDetails[item.value]"
                target="_blank"
                class="external-link d-block ml-auto"
              >
                <span class="text-decoration-underline font-semiBold-16">{{
                  item.valueText
                }}</span>
                <v-icon small icon color="primary" class="ms-1"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </v-card>
            <v-divider class="mx-4" />
          </ul>
        </v-card>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { transactionsService } from "@/services";
import renderDate from "@/mixins/renderDate";
import tableStatusItemColor from "@/mixins/tableStatusItemColor";
import Loading from "@/components/Common/Loading";

export default {
  name: "refund-details",
  components: { Loading },
  props: ["transactionId"],
  mixins: [renderDate, tableStatusItemColor],
  data() {
    return {
      refundDetails: {},
      loading: false
    };
  },
  created() {
    this.getRefundTrxDetails();
  },
  methods: {
    getRefundTrxDetails() {
      this.loading = true;
      transactionsService
        .getRefundTrxById(this.transactionId)
        .then(response => {
          this.refundDetails = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "Details";
</style>
